export enum BoxQuestionnaireStatus {
  Ended = 'ENDED',
  Filled = 'FILLED',
  Pending = 'PENDING',
}
